import React, { Component } from "react";

import {
  BrowserRouter,
  Route,
  Switch
  //Redirect
} from "react-router-dom";

import Headerbar from "./components/elements/Headerbar";

import Search from "./components/page/Search";
import Client from "./components/page/Client";
import PersonEdit from "./components/page/PersonEdit";
import Frontpage from "./components/page/Frontpage";
import Jobs from "./components/page/Jobs";
import Log from "./components/page/Log";
import Maillog from "./components/page/Maillog";
import Groups from "./components/page/Groups";
import Loaderbar from "./components/elements/Loaderbar";

import moment from "moment";
moment.locale('nb');

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      params: [],
      headerDisabled: false
    };

    this.searchParams = this.searchParams.bind(this);
    this.disableHeader = this.disableHeader.bind(this);
  }

  searchParams(params) {
    this.setState({
      params: params
    });
  }

  disableHeader(disabled) {
    this.setState({
      headerDisabled: disabled
    });
  }

  render() {
    return (
      <BrowserRouter>
        <div className="main">
          <Loaderbar />
          <Headerbar
            searchParams={this.searchParams}
            Params={this.state.params}
            Disabled={this.state.headerDisabled}
          />
          <Switch>
            <Route path="/log" component={Log} />
            <Route path="/client/:id" component={Client} />
            <Route path="/client" component={Client} />
            <Route path="/person/:id" component={PersonEdit} />
            <Route path="/person" component={PersonEdit} />
            <Route path="/jobs" component={Jobs} />
            <Route path="/mails" component={Maillog} />
            <Route path="/groups/:id" component={Groups} />
            <Route path="/groups" component={Groups} />
            <Route
              path="/search"
              render={routeProps => (
                <Search
                  {...routeProps}
                  searchParams={this.searchParams}
                  disableHeader={this.disableHeader}
                  Params={this.state.params}
                />
              )}
            />
            <Route
              path="/search/:operation/:date"
              render={routeProps => (
                <Search
                  {...routeProps}
                  searchParams={this.searchParams}
                  disableHeader={this.disableHeader}
                  Params={this.state.params}
                />
              )}
            />
            <Route
              path="*"
              render={routeProps => (
                <Frontpage
                  {...routeProps}
                  searchParams={this.searchParams}
                  Params={this.state.params}
                />
              )}
            />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
